import { Box, Container, Flex, Text } from '@mantine/core';
import { useState } from 'react';
import { useZxing } from 'react-zxing';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../config/RoutesName';

const ScanQrCode = () => {
  const [result, setResult] = useState('');
  const navigate = useNavigate();

  const { ref } = useZxing({
    onResult(result) {
      setResult(result.getText());
      navigate(ROUTES.HOME);
    },
    onError(error) {
      console.log('scan err=>', error);
    },
  });

  return (
    <>
      <Container>
        <Box display={'flex'} ta='center' mih={'65vh'} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Flex maw='65%' direction='column'>
            <video ref={ref} />
          </Flex>
        </Box>
        <Box display='flex' fw={500} style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
          <Text fz={'16px'} color='#7E7E7E' ta={'center'}>
            Can’t scan the code?
          </Text>
          &nbsp;
          <Text fz={'16px'} color='#7E7E7E' ta={'center'}>
            Please exit and relaunch the app
          </Text>
        </Box>
      </Container>
    </>
  );
};

export default ScanQrCode;
